GeoJSONLayer = App.loadClass 'grower::handlers/data/GeoJSON_Layer'

class exports.Layer_Management_Zones extends GeoJSONLayer
    constructor: () ->
        super()
        @useSlider = false
        @fetchUrl = 'backend/grower/layers/management-zones/get'

    initSlider: () ->
        @slider = @sidebar_row?.find('.shapefile-slider')
